import BaseService from 'services/api/BaseService';
import { AuthUrls, UserUrls } from 'services/api/urls';

class AuthService {
  static get_userInfo = () => {
    return BaseService.getRequest(UserUrls.GET_CONNECTED_INFO, true);
  };

  static password_login = (info: any) => {
    return BaseService.postRequest(AuthUrls.PASSWORD_LOGIN, info, false);
  };

  static impersonate = (token: string) => {
    return BaseService.postRequest(AuthUrls.IMPERSONATE, { token }, false);
  };

  static reset_password_init = (email: string) => {
    return BaseService.postRequest(
      AuthUrls.RESET_PASSWORD_INIT,
      { email },
      false,
    );
  };

  static reset_password = (info: any) => {
    return BaseService.postRequest(AuthUrls.RESET_PASSWORD, info, false);
  };

  static create_password = (info: any) => {
    return BaseService.postRequest(AuthUrls.CREATE_PASSWORD, info, false);
  };

  static change_password = (info: any) => {
    return BaseService.putRequest(AuthUrls.PASSWORD_CHANGE, info, true);
  };

  static update_profile = (info: { firstname: string; lastname: string }) => {
    return BaseService.putRequest(AuthUrls.UPDATE_PROFILE, info, true);
  };

  static verify_activation_token = (token: string) => {
    const url = `${AuthUrls.VERIFY_ACTIVATION_TOKEN}?token=${token}`;
    return BaseService.getRequest(url, false);
  };

  static resend_activation = (token: string) => {
    return BaseService.postRequest(
      AuthUrls.RESEND_ACTIVATION,
      { token },
      false,
    );
  };
}

export default AuthService;
